@if (!confirmPageDisplay) {
  <div class="p-grid" style="max-width: 900px; margin: auto;">
    <div class="col-12">
      <h4>Schedule Your Appointment</h4>
    </div>
    <div class="col-12">
      This quote option includes a scheduled 45-minute face-to-face meeting with a Russell Tree Experts ISA Certified Arborist® to discuss your landscape.
      You will also receive a detailed quote following our visit. It's priced at $100 and will be credited back to you if you purchase $500+ of resulting work.
    </div>
    <!-- Removed calendar here -->
    <div class="col-12">
      <!-- Loop over a week from the start date -->
      @for (day of displayAvailable; track day) {
        <div class="row ">
          <h6 class="col-12">{{day.day | date:'EEEE, LLLL d'}}</h6>
          @for (time of day.times; track time) {
            <div class="col-12 col-md-4 col-lg-3 light-pad">
              <p-button fluid severity="info" class="smaller-button content-to-hide-small" [label]="(time.time | date:'h:mm a') + ' - ' + time.employeeName" (click)="eventSelect(time)"></p-button>
              <p-button fluid severity="info" class="content-to-hide-large" [label]="(time.time | date:'h:mm a') + ' - ' + time.employeeName" (click)="eventSelect(time)"></p-button>
            </div>
          }
          @if (day.times.length == 0) {
            <div class="col-12">
              No times available for this day.
            </div>
          }
        </div>
      }
      <h6 class="col-12 blue-link" (click)="clickForMore()">
        &#8595; Load More Options &#8595;
      </h6>
    </div>
  </div>
}

@if (confirmPageDisplay) {
  <div class="row" style="max-width: 900px; margin: auto;">
    <div class="col-12">
      <h4>Confirm & Pay</h4>
      <div>
        <h6>Appointment:</h6>
        <div class="margin-bottom">
          {{selectedTime.time | date:'EEEE, LLLL d, h:mm a'}}
        </div>
        <h6>Location:</h6>
        <div class="margin-bottom">
          {{quoteRequest.address.street}}, {{quoteRequest.address.city}}, {{quoteRequest.address.state.abbreviation}} {{quoteRequest.address.zip}}
        </div>
        <h6>Your Arborist:</h6>
        @if (selectedRM.employeeSignature) {
          <div class="margin-bottom" style="white-space: pre-wrap">
            {{selectedRM.employeeSignature}}
          </div>
        }
        @if (!selectedRM.employeeSignature) {
          <div class="margin-bottom">
            {{selectedRM.firstName}} {{selectedRM.lastName}}
          </div>
        }
        @if (!selectedRM.employeeSignature) {
          <div class="margin-bottom">
            {{selectedRM.phoneNumber | phoneNumber}}
          </div>
        }
      </div>
      <div style="padding-top:4px">
        <app-quote-billing [quoteId]="quoteId" (billingSaved)="onPaymentSuccess()" [maxWidth]="'900px'" [isQuoteRequest]="true" [eventStart]="selectedTime.time"></app-quote-billing>
      </div>
      <div class="text-center">
        <span class="blue button-text" (click)="confirmPageDisplay=false"><< Go Back to Schedule <<</span>
      </div>
    </div>
  </div>
}

<p-confirmDialog [key]="1"></p-confirmDialog>
